import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/it.ts
var add = "Inserisci";
var remove = "Rimuovi";
var removeAll = "Rimuovi tutti";
var incomplete = "Ci dispiace, non tutti i campi sono compilati correttamente.";
var submit = "Invia";
var noFiles = "Nessun file selezionato";
var moveUp = "Sposta in alto";
var moveDown = "Sposta giù";
var isLoading = "Caricamento...";
var loadMore = "Carica altro";
var next = "Prossimo";
var prev = "Precedente";
var addAllValues = "Aggiungi tutti i valori";
var addSelectedValues = "Aggiungi valori selezionati";
var removeAllValues = "Rimuovi tutti i valori";
var removeSelectedValues = "Rimuovi i valori selezionati";
var chooseDate = "Scegli la data";
var changeDate = "Cambia data";
var close = "Chiudi";
var open = "Aperta";
var accepted = function({
  name
}) {
  return `Si prega di accettare ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `la data ${sentence(name)} deve essere successiva ${date(args[0])}.`;
  }
  return `la data ${sentence(name)} deve essere nel futuro.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} può contenere solo caratteri alfanumerici.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} può contenere solo lettere e numeri.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} può contenere solo lettere e spazi.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} deve contenere caratteri alfabetici.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} deve contenere lettere o numeri.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} deve contenere lettere o spazi.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} deve contenere un simbolo.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} must contain uppercase.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} deve contenere lettere minuscole.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} deve contenere numeri.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} deve essere un simbolo.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} può contenere solo lettere maiuscole.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} può contenere solo lettere minuscole.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `la data ${sentence(name)} deve essere antecedente ${date(args[0])}.`;
  }
  return `${sentence(name)} deve essere nel passato.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Questo campo è stato configurato male e non può essere inviato.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} deve essere tra ${a} e ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} non corrisponde.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} non è una data valida, per favore usa il formato ${args[0]}`;
  }
  return "Questo campo è stato configurato in modo errato e non può essere inviato.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} deve essere tra ${date(args[0])} e ${date(args[1])}`;
};
var email = "Per favore inserire un indirizzo email valido.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} non termina con ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} non è un valore consentito.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} deve contenere almeno un carattere.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} deve essere minore o uguale a ${max2} caratteri.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} deve contenere ${max2} caratteri.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} deve essere maggiore o uguale a ${min2} caratteri.`;
  }
  return `${sentence(name)} deve essere tra ${min2} e ${max2} caratteri.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} non è un valore consentito.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Non può avere più di ${args[0]} ${name}.`;
  }
  return `${sentence(name)} deve essere minore o uguale a ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Formato file non consentito.";
  }
  return `${sentence(name)} deve essere di tipo: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Non può avere meno di ${args[0]} ${name}.`;
  }
  return `${sentence(name)} deve essere almeno ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" non è un ${name} consentito.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} deve essere un numero.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" o ")} è richiesto.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} è richiesto.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} non inizia con ${list(args)}.`;
};
var url = function() {
  return `Inserisci un URL valido.`;
};
var invalidDate = "La data selezionata non è valida.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var it_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, it_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=it.mjs.map